// extracted by mini-css-extract-plugin
export default {"rating":"vH-z","numberOfStars":"wH-z","count":"xH-z","barGraphSpacing":"yH-z","barGraph":"zH-z"};